export default __webpack_public_path__ + "static/matrix-world-c4fd9ed40aa75fa65c061e5e801dc471.png";